module.exports = __webpack_public_path__ + "img/logo_primary.01b34f96.png";